import "./App.css";
import { Route, Routes } from 'react-router-dom';
import Home from './components/pages/Home/Home';
import Contact from './components/pages/Contact/Contact';
import AboutPage from "./components/pages/Aboutpage/AboutPage";
import IndividualService from "./components/pages/services/IndividualService";
import ScrollTop from "./components/common/ScrollTop";
import ServicePage from "./components/pages/ServicePage/ServicePage";

function App() {
  return (
 <>
 <ScrollTop/>
 <Routes>
  <Route path='/' element={<Home/>}/>
  <Route path='/about' element={<AboutPage/>}/>
  <Route path='/what-we-do' element={<ServicePage/>}/>
  <Route path='/:service/:id' element={<IndividualService/>}/>
  <Route path='/contact' element={<Contact/>}/>
 </Routes>
 </>
  );
}


export default App;
